<template>
  <div class="px-4 pb-2 pt-1">
    <v-row>
      <div :class="show ? 'col-12' : 'col-12'">
        <v-card elevation="0" style="height: 100%">
          <v-card-title style="cursor: pointer" class="d-flex align-center">
            <div>
              {{ $t("_informations_") }}
            </div>

            <div class="ml-6">
              <v-btn @click="showSiteParameters = true">
                {{ $t("_site_parameters_") }}
              </v-btn>

              <SiteParametersDialog v-model="showSiteParameters" />
            </div>
          </v-card-title>

          <hr v-show="show" />

          <v-card-text>
            <v-row v-show="show">
              <v-col
                v-for="information in informations"
                :key="information.index"
                :class="information.index == 'address' ? 'col-3' : ''"
              >
                <div>
                  {{ information.text }}
                </div>
                <div class="dark--text">
                  <span>{{ installation[information.index] }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <hr v-show="show" />

          <div style="display: flex">
            <dashboardSiteClean :liste_dashboard="list_total" />
            <v-card
              style="
                flex: 1;
                margin-top: 10px;
                margin-left: 5px;
                margin-right: 10px;
              "
              elevation="0"
            >
              <MapSiteClean :liste_fleet="liste_fleet" :selectsite="nbr_site" />
            </v-card>
          </div>
        </v-card>
      </div>
    </v-row>
  </div>
</template>

<script>
import MapSiteClean from "./MapSiteClean.vue";
import dashboardSiteClean from "./dashboardSiteClean.vue";
import SiteParametersDialog from "../../../components/parameters/SiteParametersDialog.vue"

export default {
  components: {
    MapSiteClean,
    dashboardSiteClean,
    SiteParametersDialog,
  },

  props: {
    selected_date: {
      type: String,
      required: false,
    },
    liste_fleet: { type: [Array, Object], default: () => [] },
    list_total: { type: [Array, Object], default: () => [] },
    nbr_site: {
      type: Array,
      required: false,
    },
  },
  data() {
    return {
      informations: [],
      show: true,
      showSiteParameters: false,
    };
  },
  watch: {
    selected_date: {
      handler() {
        this.list_total;
      },
    },
    "$root.$i18n.locale": {
      async handler() {
        await this.refresh_header_values();
      },
      immediate: true,
      deep: true,
    },
    $route: {
      async handler() {
        await this.refresh_header_values();
      },
      immediate: true,
    },
  },
  computed: {
    installation() {     
      return this.$store.getters.installations.find(
        (x) => x.id == this.$route.params.id
      );
    },
  },

  methods: {
    toggleCard() {
      this.show = !this.show;
    },
    refresh_header_values() {
      this.informations = [
        {
          index: "build_date",
          text: this.$t("_mise_en_service_"),
        },
        {
          index: "address",
          text: this.$t("_adresse_"),
        },
        {
          index: "installation_type",
          text: this.$t("_type_d_installation_inclinaison_orientation_"),
        },
        {
          index: "company_name",
          text: this.$t("_company_name_"),
        },
        {
          index: "installed_power_kwc",
          text: this.$t("_puissance_crete_(kwc)_"),
        },
      ];
    },
  },
};
</script>

<style scoped>
.btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
}
hr {
  margin: 0 14px;
  border: 0;
  border-top: 1px solid lightgray;
}
</style>
